import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const BoardsSelectionLoadingModal = () => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Background overlay */}
      <div className="fixed inset-0 bg-black opacity-50"></div>

      {/* Modal Box */}
      <div
        className="relative bg-white rounded-lg shadow-lg z-60"
        style={{ width: "740px", height: "690px", overflow: "hidden" }}
      >
        {/* Header */}
        <div className="sticky top-0 bg-white p-4 border-b border-gray-200 z-10">
          <div className="flex justify-between">
            <div className="flex space-x-2 items-center">
              <Skeleton width={120} height={24} />
              <div className="w-[2px] h-[18px] bg-[#4b4b4b]"></div>
              {Array.from({ length: 3 }).map((_, i) => (
                <Skeleton key={i} width={60} height={24} />
              ))}
            </div>
            <Skeleton width={20} height={20} />
          </div>
        </div>

        {/* Image grid */}
        <div
          className="overflow-y-auto"
          style={{ maxHeight: "calc(680px - 130px)" }}
        >
          <div className="grid grid-cols-4 gap-2 ml-4 mr-4 mb-10 mt-2">
            {Array.from({ length: 12 }).map((_, index) => (
              <div
                key={index}
                className="relative w-40 h-48 flex flex-col justify-center items-center"
              >
                <Skeleton height={192} width={160} className="rounded-lg" />
                <div className="w-4 h-4 bg-white rounded-full absolute top-2 right-4 flex items-center justify-center">
                  <Skeleton circle height={16} width={16} />
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom Pagination + Button */}
        <div className="p-2  absolute bg-white w-full bottom-0 flex flex-col items-center justify-center">
          <Skeleton width={100} height={20} className="mb-2" />
          <Skeleton width="75%" height={40} borderRadius={999} />
        </div>
      </div>
    </div>
  );
};

export default BoardsSelectionLoadingModal;
